import React from 'react';
import './App.css';
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import Home from "./pages/home/Home";
import RSVP from "./pages/rsvp/RSVP";
import Gallery from "./pages/gallery/Gallery"
import "./css/nav.css"
import Itinerary from "./pages/itinerary/Itinerary";
import Accommodations from "./pages/accomodations/Accommodations";
import Faq from "./pages/faq/Faq";
import ThingsToDo from "./pages/thingstodo/ThingsToDo";
import Transportation from "./pages/transportation/Transportation";

function App() {
  return (
    <BrowserRouter>
      <Routes>
          <Route path="/" element={<Navigate to="/home" replace={true}/>}/>
          <Route path="/home" element={<Home />}/>
          <Route path="/rsvp" element={<RSVP />}/>
          <Route path="/itinerary" element={<Itinerary />}/>
          <Route path="/gallery" element={<Gallery/>}/>
          <Route path="/accommodations" element={<Accommodations />}/>
          <Route path="/faq" element={<Faq />}/>
          <Route path="/things-to-do" element={<ThingsToDo />}/>
          <Route path="/transportation" element={<Transportation />}/>
          <Route
              path="*"
              element={<Navigate to="/" replace={true} />}
          />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
